import styled from '@emotion/styled';

export const S = {
  Container: styled.div(({ theme }) => ({
    display: 'flex',
    gap: theme.eclipseTier1.spacing['16px'],
  })),
};
